import { useCallback, useEffect, useState } from 'react'
import { type UseInfiniteQueryResult } from '@tanstack/react-query'
import { getErrorStatus } from '@/features/shared/utils/dataFetching/utils'

type Props = Pick<
  UseInfiniteQueryResult,
  'hasNextPage' | 'fetchNextPage' | 'isFetchingNextPage' | 'error'
> & { page: number }

export const useInfiniteLoadingGrid = ({
  page,
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
  error,
}: Props) => {
  const [nextPage, setNextPage] = useState(page)
  const [prevPage, setPrevPage] = useState(page)
  const is401Error = getErrorStatus(error) === 401

  if (page && page !== prevPage) {
    setNextPage(page)
    setPrevPage(page)
  }

  useEffect(() => {
    if (!is401Error && hasNextPage && !isFetchingNextPage && nextPage === page + 1) {
      fetchNextPage()
    }
  }, [is401Error, hasNextPage, isFetchingNextPage, fetchNextPage, nextPage, page])

  const handleSetNextPage = useCallback(() => {
    if (hasNextPage && !isFetchingNextPage) setNextPage((p) => p + 1)
  }, [hasNextPage, isFetchingNextPage])

  return { handleSetNextPage, nextPage }
}
